import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-z', 'LetterZ', [["path",{"d":"M7 4h10l-10 16h10"}]]);